export const IMAGE_BASE_URL = 'https://globalstatic.xangle.io/explorer/nexon'
export const SVG_BASE_URL = 'https://globalstatic.xangle.io/svg'
export const NFT_FALLBACK_IMAGE_URL = `${IMAGE_BASE_URL}/character/error/nft_fallback.svg`